<template>
  <div class="propertyContractAdd">
    <el-card>
      <div class="flexBox">
        <el-tabs @tab-click="handleClick" v-model="activeTabName">
          <el-tab-pane label="物业合同信息" name="0"></el-tab-pane>
          <el-tab-pane label="物业收费标准" name="1"></el-tab-pane>
          <el-tab-pane label="项目负责人信息" name="2"></el-tab-pane>
        </el-tabs>
        <div class="jump-btn">
          <el-button type="primary" @click="back">{{$t('lang.btn_wj_returnNews')}}</el-button>
        </div>
      </div>
      <!-- 企业基本信息 -->
      <el-form v-show="tabIndex==0" :model="ruleForm" name="frm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws8" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item tem label="物业企业名称" prop="enterpriseName">
          <el-input v-model="ruleForm.enterpriseName" placeholder="请输入物业企业名称" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="建设单位名称" prop="constructionName">
          <el-input v-model="ruleForm.constructionName" placeholder="请输入建设单位名称" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="项目所在区" prop="administrativeRegion">
          <el-select v-model="ruleForm.administrativeRegion" placeholder="请选择">
            <el-option v-for="item in administrativeRegion" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="项目名称" prop="projectName">
          <el-input v-model="ruleForm.projectName" placeholder="请输入项目名称" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="项目地址" prop="projectAddress">
          <el-input v-model="ruleForm.projectAddress" placeholder="请输入项目地址" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="合同名称" prop="contractName">
          <el-input v-model="ruleForm.contractName" placeholder="请输入合同名称" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="合同类别" prop="contractType">
          <el-select v-model="ruleForm.contractType" placeholder="请选择">
            <el-option v-for="item in contractType" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="物业选聘方式" prop="selectMode">
          <el-select v-model="ruleForm.selectMode" placeholder="请选择">
            <el-option v-for="item in selectMode" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="招标人" prop="biddingName">
          <el-input v-model="ruleForm.biddingName" placeholder="请输入招标人" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="中标人" prop="winBiddingName">
          <el-input v-model="ruleForm.winBiddingName" placeholder="请输入中标人" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="招标代理公司" prop="biddingAgencyCompany">
          <el-input v-model="ruleForm.biddingAgencyCompany" placeholder="请输入招标代理公司" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="物业服务经营方式" prop="managementType">
          <el-select v-model="ruleForm.managementType" placeholder="请选择">
            <el-option v-for="item in managementType" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同签订日期" prop="contractSignDate">
          <el-date-picker value-format="yyyy-MM-dd" type="date" placeholder="选择日期" v-model="ruleForm.contractSignDate">
          </el-date-picker>
        </el-form-item>
        <el-form-item tem label="甲方名称" prop="firstPartyName">
          <el-input v-model="ruleForm.firstPartyName" placeholder="请输入甲方名称" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="甲方负责人电话" prop="firstPartyPhoneNum">
          <el-input v-model="ruleForm.firstPartyPhoneNum" placeholder="请输入甲方负责人电话" class="item-input" maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item tem label="乙方名称" prop="secondPartyName">
          <el-input v-model="ruleForm.secondPartyName" placeholder="请输入乙方名称" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="乙方负责人电话" prop="secondPartyPhoneNum">
          <el-input v-model="ruleForm.secondPartyPhoneNum" placeholder="请输入乙方负责人电话" class="item-input" maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item label="合同开始日期" prop="contractDate1">
          <el-date-picker value-format="yyyy-MM-dd" type="date" placeholder="选择日期" v-model="ruleForm.contractDate1">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合同截止日期" prop="contractDate2">
          <!-- <el-date-picker v-if="ruleForm.contractType==2" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"
            v-model="ruleForm.contractDate2">
          </el-date-picker> -->
          <el-input placeholder="请输入合同截止日期" v-model="ruleForm.contractDate2"
            class="item-input" maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item label="物业服务合同" prop="contractPhoto" ref="contractPhoto">
          <upload-morefiles ref="uploading" :accept='accept' upTypes='2' :fileList='contractPhotoList' :clears='clears'
            @outputFile="getContractPhoto" @removeFile='removeContractPhoto'></upload-morefiles>

          <!-- <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="contractPhotoList"
            @outputFile="getContractPhoto" @removeFile="removeContractPhoto"></upload-file> -->
        </el-form-item>
        <el-form-item label="招标备案通知书" prop="bidNoticePhoto" ref="bidNoticePhoto">
          <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="bidNoticePhotoList"
            @outputFile="getBidNoticePhoto" @removeFile="removeBidNoticePhoto"></upload-file>
        </el-form-item>
        <el-form-item label="中标通知书" prop="winBinNoticePhoto" ref="winBinNoticePhoto">
          <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="winBinNoticePhotoList"
            @outputFile="getWinBinNoticePhoto" @removeFile="removeWinBinNoticePhoto"></upload-file>
        </el-form-item>
        <el-form-item label="补充条款" prop="supplyClausePhoto" ref="supplyClausePhoto">
          <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="supplyClausePhotoList"
            @outputFile="getSupplyClausePhoto" @removeFile="removeSupplyClausePhoto"></upload-file>
        </el-form-item>
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" :disabled="isDisabled" @click="save('ruleForm')">
          {{$t('lang.btn_save')}}
        </el-button>
      </el-form>
      <!-- 物业收费标准 -->
      <el-button v-show="tabIndex==1" type="primary" style="float:right;margin-bottom:10px;" @click="add">新增</el-button>
      <el-table v-show="tabIndex==1" :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100" :row-class-name="tableRowClassName">
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="payType" label="收费类型">
          <template slot-scope="scope">
            <span v-if="scope.row.payType == 1">物业管理费（不含电梯费）</span>
            <span v-if="scope.row.payType == 2">物业管理费（含电梯费）</span>
            <span v-if="scope.row.payType == 3">电梯使用费</span>
            <span v-if="scope.row.payType == 4">车位管理费</span>
          </template>
        </el-table-column>
        <el-table-column prop="payInfo" label="缴费说明">
          <template slot-scope="scope">
            <span v-if="scope.row.payInfo == 1">高层</span>
            <span v-if="scope.row.payInfo == 2">多层</span>
            <span v-if="scope.row.payInfo == 3">别墅</span>
            <span v-if="scope.row.payInfo == 4">商业网点</span>
            <span v-if="scope.row.payInfo == 5">洋房</span>
            <span v-if="scope.row.payInfo == 6">公寓</span>
            <span v-if="scope.row.payInfo == 7">写字间</span>
            <span v-if="scope.row.payInfo == 8">其他</span>
            <span v-if="scope.row.payInfo == 9">电梯费</span>
            <span v-if="scope.row.payInfo == 10">地上车位</span>
            <span v-if="scope.row.payInfo == 11">地下车位</span>
            <span v-if="scope.row.payInfo == 12">地上车库</span>
            <span v-if="scope.row.payInfo == 13">地下车库</span>
          </template>
        </el-table-column>
        <el-table-column prop="propertyPrice" label="单价">
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination v-show="tabIndex==1" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNo" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper" :page-count="pageCount" />
      <!-- 项目负责人信息 -->
      <el-form v-show="tabIndex==2" :model="ruleForm1" name="frm" :rules="rules1" ref="ruleForm1" class="wid100"
        :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item tem label="负责人姓名" prop="leaderName">
          <el-input v-model="ruleForm1.leaderName" placeholder="请输入负责人姓名" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="证件类型" prop="certificateType">
          <el-select v-model="ruleForm1.certificateType" placeholder="请选择">
            <el-option v-for="item in certificateType" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="身份证号" prop="leaderIdCardNum">
          <el-input v-model="ruleForm1.leaderIdCardNum" placeholder="请输入身份证号" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="手机号码" prop="leaderPhoneNum">
          <el-input v-model="ruleForm1.leaderPhoneNum" placeholder="请输入电话号码" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-button class="btn-first" @click="resetForm1('ruleForm1')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" :disabled="isDisabled1" @click="save1('ruleForm1')">
          {{$t('lang.btn_save')}}
        </el-button>
      </el-form>
    </el-card>
    <!-- 新增物业收费标准弹窗 -->
    <el-dialog title="新增收费标准" :visible.sync="dialogVisible" :close-on-click-modal="false" center top="130px"
      width="600px">
      <el-form :model="ruleForm2" name="frm" :rules="rules2" ref="ruleForm2" class="wid100"
        :label-width="require('@/config/enum').c_ws8" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item tem label="缴费类型" prop="payType">
          <el-select v-model="ruleForm2.payType" placeholder="请选择">
            <el-option v-for="item in payType" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="缴费说明" prop="payInfo">
          <el-select v-model="ruleForm2.payInfo" placeholder="请选择">
            <el-option v-for="item in payInfo" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="物业费单价（元/㎡）" prop="propertyPrice">
          <el-input v-model="ruleForm2.propertyPrice" placeholder="请输入物业费单价" class="item-input" style="width:100%"
            maxlength="50">
          </el-input>
        </el-form-item>
        <div class="jump-btn" style="text-align:center">
          <el-button class="detailbtn" type="primary" @click="save2('ruleForm2')">
            保存
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:propertyContractAdd
   *@Description:新增物业服务合同
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  import {
    mapGetters
  } from 'vuex'
  import uploadmoreFile from '../../components/upload_morefile.vue'
  import uploadmoreFiles from '../../components/upload_morefiles.vue'
  export default {
    data() {
      return {
        clears: false, // 清空按钮
        // 企业基本信息
        id: '', // 合同id
        accept: '.jpg, .jpeg, .png,',
        tabIndex: 0, // tab栏下标
        activeTabName: '0', // tab默认值
        administrativeRegion: this.$i18n.t('lang.administrativeRegion'),
        contractType: this.$i18n.t('lang.contractType'),
        selectMode: this.$i18n.t('lang.selectMode'),
        managementType: this.$i18n.t('lang.managementType'),
        certificateType: this.$i18n.t('lang.certificateType'),
        payType: this.$i18n.t('lang.payType'),
        payInfo: '',
        saveData: '',
        isDisabled: true, // 保存的可点击
        contractPhotoList: [], // 服务合同文件集合
        bidNoticePhotoList: [], // 招标备案通知书文件集合
        winBinNoticePhotoList: [], // 中标通知书文件集合
        supplyClausePhotoList: [], // 补充条款文件集合
        rules: {
          enterpriseName: [{
            required: true,
            message: '请输入物业企业名称',
            trigger: 'blur'
          }],
          // constructionName: [{
          //   required: true,
          //   message: '请输入建设单位名称',
          //   trigger: 'blur'
          // }],
          // administrativeRegion: [{
          //   required: true,
          //   message: '请选择项目所在区',
          //   trigger: 'change'
          // }],
          // projectName: [{
          //   required: true,
          //   message: '请输入项目名称',
          //   trigger: 'blur'
          // }],
          // projectAddress: [{
          //   required: true,
          //   message: '请输入项目地址',
          //   trigger: 'blur'
          // }],
          contractName: [{
            required: true,
            message: '请输入合同名称',
            trigger: 'blur'
          }],
          // contractType: [{
          //   required: true,
          //   message: '请选择合同类别',
          //   trigger: 'change'
          // }],
          // selectMode: [{
          //   required: true,
          //   message: '请选择物业选聘方式',
          //   trigger: 'change'
          // }],

          // biddingName: [{
          //   required: true,
          //   message: '请输入招标人',
          //   trigger: 'blur'
          // }],
          // winBiddingName: [{
          //   required: true,
          //   message: '请输入中标人',
          //   trigger: 'blur'
          // }],
          // biddingAgencyCompany: [{
          //   required: true,
          //   message: '请输入招标代理公司',
          //   trigger: 'blur'
          // }],

          // managementType: [{
          //   required: true,
          //   message: '请选择物业服务经营方式',
          //   trigger: 'change'
          // }],
          // contractSignDate: [{
          //   required: true,
          //   message: '请选择合同签订日期',
          //   trigger: 'change'
          // }],

          // firstPartyName: [{
          //   required: true,
          //   message: '请输入甲方名称',
          //   trigger: 'blur'
          // }],
          // firstPartyPhoneNum: [{
          //     required: true,
          //     message: '请输入甲方负责人电话',
          //     trigger: 'blur'
          //   },
          //   {
          //     pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
          //     message: '请输入正确的电话号码（座机号格式：010-88888888）',
          //     trigger: 'blur'
          //   }
          // ],
          // secondPartyName: [{
          //   required: true,
          //   message: '请输入乙方名称',
          //   trigger: 'blur'
          // }],
          // secondPartyPhoneNum: [{
          //     required: true,
          //     message: '请输入乙方负责人电话',
          //     trigger: 'blur'
          //   },
          //   {
          //     pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
          //     message: '请输入正确的电话号码（座机号格式：010-88888888）',
          //     trigger: 'blur'
          //   }
          // ],
          // contractDate1: [{
          //   required: true,
          //   message: '请选择合同开始日期',
          //   trigger: 'change'
          // }],
          // contractDate2: [{
          //   required: true,
          //   message: '请输入合同截止日期',
          //   trigger: 'change'
          // }],
          // contractPhoto: [{
          //   required: true,
          //   message: '请上传物业服务合同',
          //   trigger: 'change'
          // }],
        },
        ruleForm: {
          enterpriseName: '', // 物业企业名称
          constructionName: '', // 建设单位名称
          administrativeRegion: '', // 项目所在区
          projectName: '', // 项目名称
          projectAddress: '', // 项目地址
          contractName: '', // 合同名称
          contractType: '', // 合同类别
          selectMode: '', // 物业选聘方式
          biddingName: '', // 招标人
          winBiddingName: '', // 中标人
          biddingAgencyCompany: '', // 招标代理公司
          managementType: '', // 物业服务经营方式
          contractSignDate: '', // 合同签订日期
          firstPartyName: '', // 甲方名称
          firstPartyPhoneNum: '', // 甲方负责人电话
          secondPartyName: '', // 乙方名称
          secondPartyPhoneNum: '', // 乙方负责人电话
          contractDate1: '', // 合同开始日期
          contractDate2: '', // 合同截止日期
          contractPhoto: [],
          bidNoticePhoto: [],
          winBinNoticePhoto: [],
          supplyClausePhoto: [],
        },
        rules1: {
          leaderName: [{
            required: true,
            message: '请输入负责人姓名',
            trigger: 'blur'
          }],
          certificateType: [{
            required: true,
            message: '请选择证件类型',
            trigger: 'change'
          }],
          leaderIdCardNum: [{
              required: true,
              message: '请输入身份证号',
              trigger: 'blur'
            },
            {
              pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
              message: '请输入正确的身份证号码',
              trigger: 'blur'
            }
          ],
          leaderPhoneNum: [{
              required: true,
              message: '请输入电话号',
              trigger: 'blur'
            },
            {
              pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
              message: '请输入正确的电话号码（座机号格式：010-88888888）',
              trigger: 'blur'
            }
          ],
        },
        leaderId: '', // 负责人id
        saveData1: '',
        isDisabled1: true, // 保存的可点击
        ruleForm1: {
          leaderName: '', // 负责人姓名
          certificateType: '', // 证件类型
          leaderIdCardNum: '', // 负责人身份证号
          leaderPhoneNum: '', // 负责人电话号

        },
        rules2: {
          payType: [{
            required: true,
            message: '请选择收费类型',
            trigger: 'change'
          }],
          payInfo: [{
            required: true,
            message: '请选择缴费说明',
            trigger: 'change'
          }],
          propertyPrice: [{
            required: true,
            message: '请输入物业费单价',
            trigger: 'blur'
          }],
        },
        ruleForm2: {
          payType: '', // 收费类型
          payInfo: '', // 缴费说明
          propertyPrice: '', // 物业费单价

        },
        sfbzId: '', // 收费标准id
        // 人员基本信息
        tableData: [], // 
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        dialogVisible: false, // 新增收费标准弹窗状态
      }
    },
    components: {
      'upload-morefiles': uploadmoreFiles,
      'upload-file': uploadmoreFile
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      },
      ruleForm1: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData1) {
            // 没变
            this.isDisabled1 = true
          } else {
            // 变了
            this.isDisabled1 = false
          }
        },
        deep: true,
        immediate: true
      },
      'ruleForm2.payType': function (a, b) {
        if (a == 1 || a == 2) {
          this.payInfo = this.$i18n.t('lang.payInfo')
        } else if (a == 3) {
          this.payInfo = this.$i18n.t('lang.payInfoElevator')
        } else if (a == 4) {
          this.payInfo = this.$i18n.t('lang.payInfoPark')
        }
      },

    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    created() {
      this.id = this.$route.query.id ? this.$route.query.id : ''
      this.getFormData(this.id)
      this.getLeaderInfo()
    },
    methods: {
      // 获取服务合同照片
      getContractPhoto(e) {
        this.ruleForm.contractPhoto.push(e)
        console.log(this.ruleForm.contractPhoto)
      },
      // 获取招标备案通知书照片
      getBidNoticePhoto(e) {
        this.ruleForm.bidNoticePhoto.push(e)
        console.log(this.ruleForm.bidNoticePhoto)
      },
      // 获取中标通知书照片
      getWinBinNoticePhoto(e) {
        this.ruleForm.winBinNoticePhoto.push(e)
      },
      // 获取补充条款照片
      getSupplyClausePhoto(e) {
        this.ruleForm.supplyClausePhoto.push(e)
      },
      // 删除服务合同照片
      removeContractPhoto(e) {
        this.isDisabled = false
        let list = []
        for (let i = 0; i < this.ruleForm.contractPhoto.length; i++) {
          if (this.ruleForm.contractPhoto[i] === e) {} else {
            list.push(this.ruleForm.contractPhoto[i])
          }
        }
        this.ruleForm.contractPhoto = list
      },
      // 删除招标备案通知书照片
      removeBidNoticePhoto(e) {
        this.isDisabled = false
        let list = []
        for (let i = 0; i < this.ruleForm.bidNoticePhoto.length; i++) {
          if (this.ruleForm.bidNoticePhoto[i] === e) {} else {
            list.push(this.ruleForm.bidNoticePhoto[i])
          }
        }
        this.ruleForm.bidNoticePhoto = list
      },
      // 删除中标通知书照片
      removeWinBinNoticePhoto(e) {
        this.isDisabled = false
        let list = []
        for (let i = 0; i < this.ruleForm.winBinNoticePhoto.length; i++) {
          if (this.ruleForm.winBinNoticePhoto[i] === e) {} else {
            list.push(this.ruleForm.winBinNoticePhoto[i])
          }
        }
        this.ruleForm.winBinNoticePhoto = list
      },
      // 删除补充条款照片
      removeSupplyClausePhoto(e) {
        this.isDisabled = false
        let list = []
        for (let i = 0; i < this.ruleForm.supplyClausePhoto.length; i++) {
          if (this.ruleForm.supplyClausePhoto[i] === e) {} else {
            list.push(this.ruleForm.supplyClausePhoto[i])
          }
        }
        this.ruleForm.supplyClausePhoto = list
      },
      // 切换tab
      handleClick(tab) {
        // this.tabIndex = tab.index
        if (tab.index == 1 && this.id == '') {
          this.tabIndex = 0
          this.activeTabName = '0'
          this.$message({
            type: 'info',
            message: '请先保存物业合同信息'
          })
        } else if (tab.index == 1 && this.id != '') {
          this.tabIndex = 1
          this.getTableData()
        } else {
          this.tabIndex = tab.index
        }
      },
      // 返回上一级
      back() {
        this.$router.push({
          name: 'propertyContractList'
        })
      },
      // 获取物业合同信息（编辑时获取）
      getFormData(id) {
        if (id) {
          let loading = this.$loading()
          this.$get(
            `/gardenDrawGardenContract/` + id
          ).then(
            res => {
              loading.close()
              console.log(res)
              if (res && res.errCode === 0) {
                this.ruleForm.enterpriseName = res.gardenDrawGardenContract.enterpriseName
                this.ruleForm.constructionName = res.gardenDrawGardenContract.constructionName
                this.ruleForm.administrativeRegion = res.gardenDrawGardenContract.administrativeRegion
                this.ruleForm.projectName = res.gardenDrawGardenContract.projectName
                this.ruleForm.projectAddress = res.gardenDrawGardenContract.projectAddress
                this.ruleForm.contractName = res.gardenDrawGardenContract.contractName
                this.ruleForm.contractType = res.gardenDrawGardenContract.contractType
                this.ruleForm.selectMode = res.gardenDrawGardenContract.selectMode
                this.ruleForm.biddingName = res.gardenDrawGardenContract.biddingName
                this.ruleForm.winBiddingName = res.gardenDrawGardenContract.winBiddingName
                this.ruleForm.biddingAgencyCompany = res.gardenDrawGardenContract.biddingAgencyCompany
                this.ruleForm.managementType = res.gardenDrawGardenContract.managementType
                this.ruleForm.contractSignDate = res.gardenDrawGardenContract.contractSignDate
                this.ruleForm.firstPartyName = res.gardenDrawGardenContract.firstPartyName
                this.ruleForm.firstPartyPhoneNum = res.gardenDrawGardenContract.firstPartyPhoneNum
                this.ruleForm.secondPartyName = res.gardenDrawGardenContract.secondPartyName
                this.ruleForm.secondPartyPhoneNum = res.gardenDrawGardenContract.secondPartyPhoneNum
                this.ruleForm.contractDate1 = res.gardenDrawGardenContract.contractDate1
                this.ruleForm.contractDate2 = res.gardenDrawGardenContract.contractDate2
                this.ruleForm.contractPhoto = res.gardenDrawGardenContract.contractPhoto == '' ? [] : res
                  .gardenDrawGardenContract.contractPhoto.split(',')
                this.ruleForm.bidNoticePhoto = res.gardenDrawGardenContract.bidNoticePhoto == '' ? [] : res
                  .gardenDrawGardenContract.bidNoticePhoto.split(',')
                this.ruleForm.winBinNoticePhoto = res.gardenDrawGardenContract.winBinNoticePhoto == '' ? [] : res
                  .gardenDrawGardenContract.winBinNoticePhoto.split(',')
                this.ruleForm.supplyClausePhoto = res.gardenDrawGardenContract.supplyClausePhoto == '' ? [] : res
                  .gardenDrawGardenContract.supplyClausePhoto.split(',')
                this.isDisabled = true
                let arr1 = []
                let arr2 = []
                let arr3 = []
                let arr4 = []
                let contractPhotoUrlsListArr = []
                if (res.gardenDrawGardenContract.contractPhotoUrlsList && res.gardenDrawGardenContract.contractPhotoUrlsList.length > 0) {
                  for (let i = 0; i < res.gardenDrawGardenContract.contractPhotoUrlsList.length; i++) {
                    contractPhotoUrlsListArr.push({
                      name: res.gardenDrawGardenContract.contractPhotoUrlsList[i].split('|')[1],
                      url: res.gardenDrawGardenContract.contractPhotoUrlsList[i].split('|')[0]
                    })
                  }
                }
                if (contractPhotoUrlsListArr.length > 0) {
                  arr1 = contractPhotoUrlsListArr.map(item => ({
                    name: item.name,
                    url: item.url,
                  }))
                }
                if (res.gardenDrawGardenContract.bidNoticePhoto != '') {
                  arr2 = res.gardenDrawGardenContract.bidNoticePhoto.split(',').map(item => ({
                    name: '',
                    url: item,
                  }))
                }
                if (res.gardenDrawGardenContract.winBinNoticePhoto != '') {
                  arr3 = res.gardenDrawGardenContract.winBinNoticePhoto.split(',').map(item => ({
                    name: '',
                    url: item,
                  }))
                }
                if (res.gardenDrawGardenContract.supplyClausePhoto != '') {
                  arr4 = res.gardenDrawGardenContract.supplyClausePhoto.split(',').map(item => ({
                    name: '',
                    url: item,
                  }))
                }
                this.contractPhotoList = arr1
                this.bidNoticePhotoList = arr2
                this.winBinNoticePhotoList = arr3
                this.supplyClausePhotoList = arr4
                // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
                this.saveData = JSON.stringify(this.ruleForm)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      },
      // 物业合同信息保存
      save(formName) {
        let params = this.ruleForm
        params.contractPhoto = this.ruleForm.contractPhoto.length > 0 ? this.ruleForm.contractPhoto.join(',') : ''
        params.bidNoticePhoto = this.ruleForm.bidNoticePhoto.join(',')
        params.winBinNoticePhoto = this.ruleForm.winBinNoticePhoto.join(',')
        params.supplyClausePhoto = this.ruleForm.supplyClausePhoto.join(',')
        params.gardenId = this.gardenId
        if (this.id) {
          params.id = this.id
        }
        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            if (!this.id) {
              this.$post('/gardenDrawGardenContract', params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.id = res.gardenDrawGardenContract.id
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.isDisabled = true
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else if (this.id) {
              this.$patch(`/gardenDrawGardenContract/${this.id}`, params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.isDisabled = true
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          } else {
            return false
          }
        })
      },
      // 物业合同信息清空
      resetForm(formName) {
        this.ruleForm.enterpriseName = ''
        this.ruleForm.constructionName = ''
        this.ruleForm.administrativeRegion = ''
        this.ruleForm.projectName = ''
        this.ruleForm.projectAddress = ''
        this.ruleForm.contractName = ''
        this.ruleForm.contractType = ''
        this.ruleForm.selectMode = ''
        this.ruleForm.biddingName = ''
        this.ruleForm.winBiddingName = ''
        this.ruleForm.biddingAgencyCompany = ''
        this.ruleForm.managementType = ''
        this.ruleForm.contractSignDate = ''
        this.ruleForm.firstPartyName = ''
        this.ruleForm.firstPartyPhoneNum = ''
        this.ruleForm.secondPartyName = ''
        this.ruleForm.secondPartyPhoneNum = ''
        this.ruleForm.contractDate1 = ''
        this.ruleForm.contractDate2 = ''
        this.ruleForm.contractPhoto = []
        this.ruleForm.bidNoticePhoto = []
        this.ruleForm.winBinNoticePhoto = []
        this.ruleForm.supplyClausePhoto = []
        this.contractPhotoList = []
        this.bidNoticePhotoList = []
        this.winBinNoticePhotoList = []
        this.supplyClausePhotoList = []
      },
      // ----------------------------------------------------------------------------------------
      // ----------------------------------------------------------------------------------------
      // ----------------------------------------------------------------------------------------
      // ----------------------------------------------------------------------------------------
      // ----------------------------------------------------------------------------------------
      // 物业收费标准-获取列表数据
      getTableData() {
        let loading = this.$loading()
        this.$get(
          `/gardenDrawGardenPayinfo?contractId=${this.id}&gardenId=${this.gardenId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 新增物业收费标准
      add() {
        this.dialogVisible = true
        this.sfbzId = ''
        this.ruleForm2.payType = ''
        this.ruleForm2.payInfo = ''
        this.ruleForm2.propertyPrice = ''
      },
      // 编辑物业收费标准
      edit(rowData) {
        console.log(rowData)
        this.dialogVisible = true
        this.sfbzId = rowData.id
        this.ruleForm2.payType = rowData.payType
        this.ruleForm2.payInfo = rowData.payInfo
        this.ruleForm2.propertyPrice = rowData.propertyPrice
      },
      // 新增收费标准
      save2(formName) {
        let params = this.ruleForm2
        params.gardenId = this.gardenId
        params.contractId = this.id
        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            if (!this.sfbzId) {
              this.$post('/gardenDrawGardenPayinfo', params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success('新增成功')
                    this.dialogVisible = false
                    this.getTableData()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              this.$patch('/gardenDrawGardenPayinfo/' + this.sfbzId, params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success('修改成功')
                    this.dialogVisible = false
                    this.getTableData()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          } else {
            return false
          }
        })
      },
      // 删除物业收费标准
      deleteOne(id) {
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }).then(() => {
            this.$delete(`/gardenDrawGardenPayinfo/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.getTableData()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getData()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      // ----------------------------------------------------------------------------------------
      // ----------------------------------------------------------------------------------------
      // ----------------------------------------------------------------------------------------
      // ----------------------------------------------------------------------------------------
      // ----------------------------------------------------------------------------------------
      // 获取项目负责人信息
      getLeaderInfo() {
        let loading = this.$loading()
        this.$get(`/gardenDrawGardenLeader?gardenId=${this.gardenId}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.list.length > 0) {
                this.ruleForm1.leaderName = res.list[0].leaderName
                this.ruleForm1.certificateType = res.list[0].certificateType
                this.ruleForm1.leaderIdCardNum = res.list[0].leaderIdCardNum
                this.ruleForm1.leaderPhoneNum = res.list[0].leaderPhoneNum
                this.leaderId = res.list[0].id
                this.isDisabled1 = true
                // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
                this.saveData1 = JSON.stringify(this.ruleForm1)
                console.log(this.ruleForm1)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 项目负责人信息保存
      save1(formName) {
        let params = this.ruleForm1
        params.gardenId = this.gardenId
        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            if (!this.leaderId) {
              // 新增
              this.$post('/gardenDrawGardenLeader', params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.isDisabled1 = true
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              // 编辑
              this.$patch(`/gardenDrawGardenLeader/${this.leaderId}`, params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.isDisabled1 = true
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          } else {
            return false
          }
        })
      },
      // 项目负责人信息清空
      resetForm1(formName) {
        this.ruleForm1.leaderName = ''
        this.ruleForm1.certificateType = ''
        this.ruleForm1.leaderIdCardNum = ''
        this.ruleForm1.leaderPhoneNum = ''
      },

    },
  }
</script>

<style lang="scss">
  .propertyContractAdd {
    .flexBox {
      display: flex;

      .el-tabs {
        background-color: #fff !important;
        flex: 1;
      }

      .el-tabs__nav-wrap {
        // width: 99%!important;
        position: static !important;
      }

      .el-tabs__nav-wrap::after {
        display: none;
      }

      .el-tabs__nav-scroll .el-tabs__nav.is-top .el-tabs__item:nth-last-child(2) {
        padding-left: 20px !important;
      }

      .el-tabs__nav-scroll .el-tabs__nav.is-top .el-tabs__item:last-child {
        padding-right: 20px !important;
      }
    }

    .item-input,
    .el-select,
    .el-date-editor.el-input {
      width: 30%;
    }

    .editor-width {
      width: 80%;
    }

    .item-select {
      display: inline-block
    }

    .empty-input {
      display: none
    }

    .el-upload-list,
    .el-upload-list--picture {
      display: flex;
      flex-wrap: wrap !important;
    }

    .el-upload-list__item {
      max-width: 300px;
      margin-right: 20px;
    }
  }
</style>